import React from "react";
import DashboardPage from "./DashboardPage";

const DashboardModule = () => <DashboardPage />;
export default DashboardModule;